module.exports = __webpack_public_path__ + "img/testimonial-3.cb220fb.jpg";